import React from 'react';

let defaultValue:object = [];
const SideNavContext = React.createContext(defaultValue as any);

export default SideNavContext;